import { communicationService } from '@ad-engine/communication';
import { DSA_MODAL_CLOSED } from '../../../communication/events/events-bidders';
import { CloseButton } from './close-button';
import { UiComponent, UiComponentProps } from './ui-component';

export type AdvertiserInfoDialogProps = UiComponentProps & {
	behalf: string;
	paid: string;
	slot: string;
};

export class AdvertiserInfoDialog extends UiComponent<AdvertiserInfoDialogProps> {
	private readonly dialog: HTMLDialogElement;

	constructor(props: AdvertiserInfoDialogProps) {
		super(props);
		this.dialog = document.createElement('dialog');
		this.dialog.classList.add('dsa-dialog');
		this.dialog.id = AdvertiserInfoDialog.getDialogId(props.slot);
	}

	static getDialogId(slotName: string): string {
		return `dsa-dialog-${slotName}`;
	}

	render(): HTMLDialogElement {
		this.renderHeader();
		this.renderAdvertiserInfo();

		return this.dialog;
	}

	getElement(): HTMLDialogElement {
		return this.dialog;
	}

	private renderHeader(): void {
		const header = document.createElement('header');
		header.classList.add('dsa-dialog-header');

		const title = document.createElement('h2');
		title.classList.add('dsa-dialog-title');
		title.innerText = 'About this ad';
		header.appendChild(title);
		const closeButton = new CloseButton({
			onClick: (event) => {
				event.preventDefault();
				this.dialog.close();
				communicationService.emit(DSA_MODAL_CLOSED, {
					adSlotName: this.props.slot,
				});
			},
			classNames: ['dsa-button-close'],
		}).render();
		header.appendChild(closeButton);
		this.dialog.appendChild(header);

		this.dialog.appendChild(this.renderSeparator());
	}

	private renderAdvertiserInfo(): void {
		const { behalf, paid } = this.props;

		const container = document.createElement('div');
		container.classList.add('dsa-dialog-container');

		const title = document.createElement('h3');
		title.classList.add('dsa-dialog-subtitle');
		title.innerText = 'Advertiser';
		container.appendChild(title);

		const behalfLine = document.createElement('span');
		behalfLine.innerHTML = 'On behalf: <i>' + behalf + '</i>';
		container.appendChild(behalfLine);

		const paidLine = document.createElement('span');
		paidLine.innerHTML = 'Paid by: <i>' + paid + '</i>';
		container.appendChild(paidLine);

		container.appendChild(this.renderSeparator());

		const text = document.createElement('h4');
		text.innerText = 'This ad is based on:';
		container.appendChild(text);

		const list = document.createElement('ul');
		list.style.listStyle = 'inside';
		const listItem = document.createElement('li');
		listItem.innerText = 'The information on the website you were viewing';
		list.appendChild(listItem);
		container.appendChild(list);
		this.dialog.appendChild(container);
	}

	private renderSeparator(): HTMLHRElement {
		const separator = document.createElement('hr');
		separator.classList.add('dsa-dialog-separator');
		return separator;
	}
}
